import React, { useState } from 'react';
import { Instagram, Mail } from 'lucide-react';
import './Footer.css';
import Impressum from './Impressum';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showImpressum, setShowImpressum] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/frost-logo.png" alt="Frost Studio" className="footer-logo-image" />
              </div>
              <p className="footer-tagline">
                Wir frieren Dreck weg. Professionelle Trockeneistrahlung für Industrie und Gewerbe.
              </p>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Navigation</h3>
              <ul className="footer-links">
                <li><button onClick={() => scrollToSection('home')}>Home</button></li>
                <li><button onClick={() => scrollToSection('services')}>Dienstleistungen</button></li>
                <li><button onClick={() => scrollToSection('about')}>Über Uns</button></li>
                <li><button onClick={() => scrollToSection('contact')}>Kontakt</button></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Kontakt</h3>
              <ul className="footer-contact">
                <li>kontakt@froststudio.de</li>
                <li>0162 2112584</li>
                <li>Gottfried-Keller-Straße 69</li>
                <li>01157 Dresden</li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Folgen Sie uns</h3>
              <div className="footer-social">
                <a href="https://www.instagram.com/froststud.io?igsh=eW5xMXBnZHRucXFi" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <Instagram size={24} />
                </a>
                <a href="mailto:kontakt@froststudio.de" className="social-link" aria-label="Email">
                  <Mail size={24} />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-legal">
              <button>Datenschutz</button>
              <span className="separator">•</span>
              <button onClick={() => setShowImpressum(true)}>Impressum</button>
              <span className="separator">•</span>
              <button>AGB</button>
            </div>
            <p className="footer-copyright">
              © {currentYear} Frost Studio. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </footer>
      
      <Impressum isOpen={showImpressum} onClose={() => setShowImpressum(false)} />
    </>
  );
};

export default Footer;